import { ConsignedWarehouseInfo } from './consigned-warehouse-info.class';

export interface ProductNotification {
  id: string;
  description: string;
  messageCodeId: number;
  messageTypeId: number;
  priority: number;
  supersedeProductNumber?: any;
  oemSkuProductNumbers?: any[];
  buttons?: any[];
}

export class Product {
  id: string;
  carrierMessage: string;
  lineNumber: number;
  productNumber: string;
  countryOfOrigin?: string;
  quantity: number;
  listPrice: number;
  dbNetPrice?: number;
  netPrice: number;
  total: string;
  availableQuantity: number;
  description: string;
  lineNotes: {
    notes: string;
    bomNotes: string;
  };
  notes: string;
  quoteId: string;
  notificationIcon?: string;
  notifications: ProductNotification[];
  editable: boolean;
  calculateTotals: boolean;
  isLoading: boolean;
  deletionInProgress: boolean;
  hasError: boolean;
  hasExpiredPricing?: boolean;
  oemSku: string;
  weight?: number;
  customTool?: boolean;
  updateCustomToolInProgress?: boolean;
  lineWeight?: number;
  estimatedShipDate?: string;
  supersede?: string;
  manufacturer: string;
  lifeCycle: string;
  returnable: number;
  commodityCode: string;
  repairable: number;
  directDelivery: number;
  warrantyCode: string;
  priceCategory: number;
  signalCode: string;
  minimumQuantity: number;
  alternateProduct: string;
  limitedMarketing: number;
  refreshingAtp?: boolean;
  quantityMessage?: string;
  countryId?: number;
  consignedWarehouse?: ConsignedWarehouseInfo;
  constructor() {
    this.quantity = 1;
  }

  /**
   * Creates a new object of type Product
   */
  static clone(obj: Product): Product {
    const product = new Product();
    product.id = obj.id;
    product.lineNumber = obj.lineNumber;
    product.productNumber = obj.productNumber;
    product.quantity = obj.quantity;
    product.listPrice = obj.listPrice;
    product.netPrice = obj.netPrice;
    product.total = obj.total;
    product.availableQuantity = obj.availableQuantity;
    product.description = obj.description;
    product.lineNotes = obj.lineNotes ? {
      notes: obj.lineNotes.notes,
      bomNotes: obj.lineNotes.bomNotes
    } : null;

    return product;
  }

  /**
   * Evaluates the given object to check if is equal with the current instance
   * @param secondObject - The object to check
   */
  static equals(firstObject: Product, secondObject: Product): boolean {
    return secondObject.id === firstObject.id
      && secondObject.lineNumber === firstObject.lineNumber
      && secondObject.productNumber === firstObject.productNumber
      && secondObject.quantity === firstObject.quantity
      && secondObject.listPrice === firstObject.listPrice
      && secondObject.netPrice === firstObject.netPrice
      && secondObject.total === firstObject.total
      && secondObject.availableQuantity === firstObject.availableQuantity
      && secondObject.description === firstObject.description
      && (!secondObject.lineNotes && !firstObject.lineNotes ||
        (secondObject.lineNotes && firstObject.lineNotes &&
          secondObject.lineNotes.notes === firstObject.lineNotes.notes &&
          secondObject.lineNotes.bomNotes === firstObject.lineNotes.bomNotes));
  }
}
